// extracted by extract-css-chunks-webpack-plugin
module.exports = {"arrow":"styles__arrow___kF5sJ","btn-delete":"styles__btn-delete___28Epb","btnDelete":"styles__btn-delete___28Epb"};
    if(module.hot) {
      // 1695357488611
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  